import React, { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/translations';
import { api, resolveAssetUrl } from '../utils/api';
import { CmsPageSection } from '../types/cms';

interface LogoProps {
  className?: string;
  alt?: string;
  tone?: 'light' | 'dark';
}

let brandingRequest: Promise<CmsPageSection | null> | null = null;
function loadBranding() {
  brandingRequest ||= api.getCmsPage('home')
    .then((response) => response.page?.sections?.find((item: CmsPageSection) => item.section_key === 'branding') || null)
    .catch(() => null);
  return brandingRequest;
}

export const Logo: React.FC<LogoProps> = ({ className = 'w-8 h-8', alt }) => {
  const { tx, language } = useTranslation();
  const [branding, setBranding] = useState<CmsPageSection | null>(null);
  useEffect(() => {
    let active = true;
    loadBranding().then((section) => {
      if (active && section?.is_active) setBranding(section);
    });
    return () => { active = false; };
  }, []);
  const imageAlt = branding?.decorative ? '' : alt || (language === 'ar' ? branding?.image_alt_ar || branding?.media_alt_ar : branding?.image_alt_en || branding?.media_alt_en) || tx('استهداف');
  return (
    <img
      src={resolveAssetUrl(branding?.media_url || '/logo.png')}
      alt={imageAlt}
      width={branding?.media_width || 128}
      height={branding?.media_height || 128}
      decoding="async"
      className={`brand-logo object-contain ${className}`}
    />
  );
};
